// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { UPLOAD_FILE_TYPES } from './../../../types/next/blocks/uploadBlock'
import { blockBaseSettingsSchema, iBlockSchema } from './baseBlock.zod'

export const uploadFileTypesSchema = z.nativeEnum(UPLOAD_FILE_TYPES)

export const uploadBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.FILE_UPLOAD),
  settings: blockBaseSettingsSchema.and(
    z.object({
      maxQuantity: z.number(),
      restricted: z.boolean().optional(),
      supportedTypes: uploadFileTypesSchema.optional(),
      tags: z.array(z.string()).optional(),
      zoneLabel: z.string().optional()
    })
  )
})

const s3FileSchema = z.any()

export const uploadBlockValueSchema = z.array(s3FileSchema)
